<svelte:head>
	<title>Careers - OS Studio</title>
	<meta name="description" content="Join the OS Studio team and help build the future." />
</svelte:head>

<div class="min-h-screen bg-white">
	<!-- Hero -->
	<div class="bg-gradient-to-br from-purple-900 to-blue-900 text-white py-20">
		<div class="container mx-auto px-4 max-w-6xl text-center">
			<h1 class="text-5xl font-bold mb-4">Join Our Team</h1>
			<p class="text-xl text-purple-100">Help us build the future of operating systems</p>
		</div>
	</div>

	<!-- Jobs -->
	<div class="container mx-auto px-4 max-w-6xl py-20">
		<div class="grid grid-cols-1 md:grid-cols-2 gap-8">
			<!-- Senior Backend Engineer -->
			<div class="bg-gray-50 rounded-lg p-8 border border-gray-200">
				<h3 class="text-2xl font-bold text-gray-900 mb-2">Senior Backend Engineer</h3>
				<p class="text-gray-600 mb-4">Remote • Full-time</p>
				<p class="text-gray-700 mb-6">
					We're looking for an experienced backend engineer to help build scalable APIs and infrastructure for OS Studio.
				</p>
				<ul class="text-sm text-gray-600 space-y-2 mb-6">
					<li>✓ 5+ years of backend development</li>
					<li>✓ Node.js, PostgreSQL, Redis</li>
					<li>✓ Cloud deployment experience</li>
				</ul>
				<a href="#" class="text-purple-600 hover:text-purple-700 font-semibold">Apply Now →</a>
			</div>

			<!-- Frontend Engineer -->
			<div class="bg-gray-50 rounded-lg p-8 border border-gray-200">
				<h3 class="text-2xl font-bold text-gray-900 mb-2">Frontend Engineer</h3>
				<p class="text-gray-600 mb-4">Remote • Full-time</p>
				<p class="text-gray-700 mb-6">
					Build beautiful, responsive interfaces for our app builder platform using Svelte and modern web technologies.
				</p>
				<ul class="text-sm text-gray-600 space-y-2 mb-6">
					<li>✓ Svelte / JavaScript expertise</li>
					<li>✓ UI/UX design sensibility</li>
					<li>✓ 3+ years of frontend development</li>
				</ul>
				<a href="#" class="text-purple-600 hover:text-purple-700 font-semibold">Apply Now →</a>
			</div>

			<!-- DevOps Engineer -->
			<div class="bg-gray-50 rounded-lg p-8 border border-gray-200">
				<h3 class="text-2xl font-bold text-gray-900 mb-2">DevOps Engineer</h3>
				<p class="text-gray-600 mb-4">Remote • Full-time</p>
				<p class="text-gray-700 mb-6">
					Design and maintain our cloud infrastructure, CI/CD pipelines, and deployment systems.
				</p>
				<ul class="text-sm text-gray-600 space-y-2 mb-6">
					<li>✓ Kubernetes, Docker expertise</li>
					<li>✓ AWS or GCP experience</li>
					<li>✓ Infrastructure-as-Code knowledge</li>
				</ul>
				<a href="#" class="text-purple-600 hover:text-purple-700 font-semibold">Apply Now →</a>
			</div>

			<!-- AI/ML Engineer -->
			<div class="bg-gray-50 rounded-lg p-8 border border-gray-200">
				<h3 class="text-2xl font-bold text-gray-900 mb-2">AI/ML Engineer</h3>
				<p class="text-gray-600 mb-4">Remote • Full-time</p>
				<p class="text-gray-700 mb-6">
					Improve our code generation pipeline and develop better AI models for system design.
				</p>
				<ul class="text-sm text-gray-600 space-y-2 mb-6">
					<li>✓ ML/AI expertise</li>
					<li>✓ LLM fine-tuning experience</li>
					<li>✓ Python proficiency</li>
				</ul>
				<a href="#" class="text-purple-600 hover:text-purple-700 font-semibold">Apply Now →</a>
			</div>
		</div>

		<!-- Why Join -->
		<div class="mt-20 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-12 border border-purple-200">
			<h2 class="text-3xl font-bold text-gray-900 mb-8 text-center">Why Join OS Studio?</h2>
			<div class="grid grid-cols-1 md:grid-cols-3 gap-8">
				<div>
					<h3 class="text-lg font-bold text-gray-900 mb-2">🚀 Impact</h3>
					<p class="text-gray-700">Work on technology that changes how operating systems are built</p>
				</div>
				<div>
					<h3 class="text-lg font-bold text-gray-900 mb-2">💰 Competitive Salary</h3>
					<p class="text-gray-700">Top-tier compensation with equity and benefits</p>
				</div>
				<div>
					<h3 class="text-lg font-bold text-gray-900 mb-2">🌍 Remote First</h3>
					<p class="text-gray-700">Work from anywhere with flexible schedules</p>
				</div>
				<div>
					<h3 class="text-lg font-bold text-gray-900 mb-2">📚 Learning</h3>
					<p class="text-gray-700">Unlimited learning budget and conference attendance</p>
				</div>
				<div>
					<h3 class="text-lg font-bold text-gray-900 mb-2">👥 Great Team</h3>
					<p class="text-gray-700">Work with brilliant engineers and designers</p>
				</div>
				<div>
					<h3 class="text-lg font-bold text-gray-900 mb-2">⚖️ Work-Life</h3>
					<p class="text-gray-700">Generous time off and flexible work arrangements</p>
				</div>
			</div>
		</div>
	</div>
</div>
